import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-managed-it',
  templateUrl: './managed-it.component.html',
  styleUrls: ['./managed-it.component.css']
})
export class ManagedItComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.seoService.setSEOTags(
      'Managed IT Services',
      'Professional Managed IT Services in India with 24/7 support, 99.9% uptime SLA, cybersecurity, backup & recovery, and network management. Enterprise-grade solutions for businesses of all sizes.',
      'Managed IT Services India, IT Support India, 24/7 IT Support, IT Management Services, Cybersecurity India, Network Management, Backup & Recovery, Cloud Infrastructure, Enterprise IT Solutions'
    );
  }

}
